import React from 'react';
import { FiBriefcase, FiMapPin } from 'react-icons/fi';
import timelineElements from './timelineEvents';

const WorkExperience = () => {
  return (
    <div className="mt-10 border-t border-white/10 pt-8">
      <div className="grid gap-5">
        {timelineElements.map((item) => (
          <article
            key={item.id}
            className="rounded-2xl border border-white/10 bg-white/[0.035] p-6 transition hover:border-cyan-400/30"
          >
            <div className="flex flex-col sm:flex-row sm:items-start sm:justify-between gap-3">
              <div>
                <div className="flex items-center gap-2 text-cyan-300">
                  <FiBriefcase />
                  <span className="font-semibold">{item.role}</span>
                </div>
                <h3 className="mt-2 text-2xl font-bold text-white">
                  {item.title}
                </h3>
                <p className="mt-2 flex items-center gap-2 text-sm text-gray-400">
                  <FiMapPin /> {item.location}
                </p>
              </div>
              <span className="text-sm text-gray-400 whitespace-nowrap">
                {item.date}
              </span>
            </div>
            <p className="mt-5 text-gray-300 leading-relaxed">
              {item.description}
            </p>
          </article>
        ))}
      </div>
    </div>
  );
};

export default WorkExperience;
